export const DIRECTIONS = {
  left: 'left',
  right: 'right',
};
